import React from 'react';
import styled from 'styled-components';

const HumanResource = () => {
  return (
    <HumanResourceContainer>
      <Header>
        <Title>Human Resource</Title>
        <Subtitle>Manage HR operations and employee data</Subtitle>
      </Header>
      
      <ContentArea>
        <ComingSoon>Coming Soon</ComingSoon>
        <Description>Human Resource management features will be available here.</Description>
      </ContentArea>
    </HumanResourceContainer>
  );
};

const HumanResourceContainer = styled.div`
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const Header = styled.div`
  margin-bottom: 2rem;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: ${props => props.theme.colors.dark};
  margin: 0 0 0.5rem 0;
`;

const Subtitle = styled.p`
  font-size: 1.1rem;
  color: ${props => props.theme.colors.gray[600]};
  margin: 0;
`;

const ContentArea = styled.div`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: ${props => props.theme.borders.radius};
  padding: 3rem;
  text-align: center;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ComingSoon = styled.h2`
  font-size: 2rem;
  font-weight: 600;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 1rem;
`;

const Description = styled.p`
  font-size: 1.1rem;
  color: ${props => props.theme.colors.gray[600]};
  max-width: 500px;
  line-height: 1.6;
`;

export default HumanResource;
